import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence the benign "ResizeObserver loop completed with undelivered
// notifications" error thrown by Radix (Sheet/HoverCard/etc.) internal
// size observers. This is a well-known Chrome browser quirk with zero
// functional impact; suppressing it stops the CRA dev overlay from
// masking legitimate UI interactions in dev + e2e.
const RESIZE_OBS_LOOP = "ResizeObserver loop";
window.addEventListener("error", (e) => {
  if (e?.message && e.message.startsWith(RESIZE_OBS_LOOP)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message || String(e?.reason || "");
  if (msg.startsWith(RESIZE_OBS_LOOP)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
